export interface RequestConfig {
  headers?: Record<string, string>
  signal?: AbortSignal
}

const BASE_URL = import.meta.env.VITE_API_URL || ''

async function handleResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const error = { message: response.statusText, status: response.status, code: '' }
    try {
      const data = await response.json()
      error.message = data.message || error.message
      error.code = data.code
    } catch {
      // Ignore JSON parse error
    }
    throw error
  }
  return response.json()
}

export class ApiClient {
  private baseUrl: string

  constructor(baseUrl: string = BASE_URL) {
    this.baseUrl = baseUrl
  }

  async post<T>(url: string, data?: unknown, config?: RequestConfig): Promise<T> {
    const response = await fetch(`${this.baseUrl}${url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...config?.headers,
      },
      body: data ? JSON.stringify(data) : undefined,
      signal: config?.signal,
    })
    return handleResponse<T>(response)
  }
}

export const api = new ApiClient('/api/v1')
